/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

const disallowedDomains = ['localhost', '127.0.0.1', '0.0.0.0', 'camunda.com'];

/**
 * @param {string} resourceUrl
 * @param {string[]} extraDisallowedDomains
 * @returns {boolean}
 */
export const isDisallowedDomain = (resourceUrl, extraDisallowedDomains = []) => {
  try {
    const url = new URL(resourceUrl);
    return [...disallowedDomains, ...extraDisallowedDomains].some(
      (domain) => url.hostname === domain || url.hostname.endsWith('.' + domain)
    );
  } catch {
    return true;
  }
};

/**
 * @param {string} resourceUrl
 * @returns {boolean}
 */
export const isProtocolDisallowed = (resourceUrl) => {
  try {
    const url = new URL(resourceUrl);
    return url.protocol !== 'https:' && url.protocol !== 'http:';
  } catch {
    return true;
  }
};

/**
 * @param {string} resourceUrl
 * @returns {boolean}
 */
export const isValidUrl = (resourceUrl) => {
  try {
    return Boolean(new URL(resourceUrl));
  } catch {
    return false;
  }
};

/**
 * @param {string} resourceUrl
 * @returns {boolean}
 */
export const isProtocolAllowedOrMissing = (resourceUrl) => {
  if (
    typeof resourceUrl === 'string' &&
    (!resourceUrl.includes('://') || resourceUrl.startsWith('http://') || resourceUrl.startsWith('https://'))
  ) {
    return true;
  }
  return false;
};

/**
 * @param {string} resourceUrl
 * @returns {string}
 */
export const prependHttpsIfMissing = (resourceUrl) => {
  if (!/^https?:\/\//i.test(resourceUrl)) {
    resourceUrl = `https://${resourceUrl}`;
  }

  return resourceUrl;
};
